import { LuxDt } from "./Date1TimeF.mts";
import * as _ from 'lodash-es';
export const mkMsToLuxH = (keysA) => {
    return (row) => {
        return _.mapValues(row, (val, key) => {
            if (!_.isInteger(val))
                return val;
            if (_.includes(keysA, key)) {
                return LuxDt.fromMillis(val);
            }
            return val;
        });
    };
};
